import React from "react";

export default function PropertyStatementView({ data, preview_url }) {
  if (!data) return null;

  const transactionType = (data.transaction_type || "").toLowerCase();
  const sections = Array.isArray(data.document_sections)
    ? data.document_sections
    : [];

  const headingTitle =
    transactionType === "purchase"
      ? "Property Purchase Details"
      : "Property Sale Details";

  return (
    <div className="mt-6 space-y-8">

      {/* ================= HEADER ================= */}
      <div className="bg-[#1d5aa9] p-4 rounded-lg shadow ">
        <h2 className="text-xl font-semibold">{headingTitle}</h2>
      </div>

      {/* ================= HEADER INFO ================= */}
      <div className="bg-white border rounded-lg shadow">
        <div className="bg-[#eef4ff] px-4 py-2 rounded-t-lg border-b">
          <h3 className="text-base font-semibold text-[#1d5aa9]">
            ▣ Property Statement Header Information
          </h3>
        </div>

        <table className="w-full text-sm">
          <tbody>
            <tr className="border-b">
              <td className="p-3 font-medium bg-gray-50">Client</td>
              <td className="p-3">{data.client_name || "N/A"}</td>

              <td className="p-3 font-medium bg-gray-50">
                Transaction Type
              </td>
              <td className="p-3">
                {data.transaction_type || "N/A"}
              </td>
            </tr>

            <tr className="border-b">
              <td className="p-3 font-medium bg-gray-50">
                Transaction Date
              </td>
              <td className="p-3">{data.property_date || "N/A"}</td>

              <td className="p-3 font-medium bg-gray-50">
                {transactionType === "purchase"
                  ? "Purchase Price"
                  : "Sale Price"}
              </td>
              <td className="p-3 text-green-700 font-semibold">
                £{data.property_transaction_price || "0"}
              </td>
            </tr>

            <tr className="border-b">
              <td className="p-3 font-medium bg-gray-50">
                Property Address
              </td>
              <td className="p-3" colSpan={3}>
                {data.property_address || "N/A"}
              </td>
            </tr>

            <tr className="border-b">
              <td className="p-3 font-medium bg-gray-50">
                Solicitor Firm
              </td>
              <td className="p-3">
                {data.solicitor_firm || "N/A"}
              </td>

              <td className="p-3 font-medium bg-gray-50">
                Matter Reference
              </td>
              <td className="p-3">
                {data.matter_reference || "N/A"}
              </td>
            </tr>

            <tr className="border-b">
              <td className="p-3 font-medium bg-gray-50">
                {transactionType === "purchase"
                  ? "Payments Made"
                  : "Payments Received"}
              </td>
              <td className="p-3 text-green-700 font-semibold">
                £{data.total_payments_received || "0"}
              </td>

              <td className="p-3 font-medium bg-gray-50">
                Total Fees
              </td>
              <td className="p-3 text-blue-700 font-semibold">
                £{data.total_fees || "0"}
              </td>
            </tr>

            <tr className="border-b">
              <td className="p-3 font-medium bg-gray-50">
                Stamp Duty / Tax
              </td>
              <td className="p-3 text-orange-600 font-semibold">
                £{data.total_tax || "0"}
              </td>

              <td className="p-3 font-medium bg-gray-50">
                Total Disbursements
              </td>
              <td className="p-3 font-semibold">
                £{data.total_disbursements || "0"}
              </td>
            </tr>

            {/* ===== CLIENT DUE (PURCHASE ONLY) ===== */}
            {transactionType === "purchase" && (
              <tr>
                <td className="p-3 font-medium bg-gray-50">
                  Client Due Amount
                </td>
                <td className="p-3 text-red-600 font-bold">
                  £{data.client_due_amount || "0"}
                </td>
                <td className="p-3 bg-gray-50"></td>
                <td className="p-3"></td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* ================= PAYMENT SECTIONS ================= */}
      <div className="bg-white border rounded-lg shadow">
        <div className="bg-[#1d8b5a] px-4 py-2 rounded-t-lg">
          <h3 className="text-base font-semibold ">
            Payment Details – As Document Sections
          </h3>
        </div>

        {sections.length === 0 && (
          <div className="p-4 text-sm text-gray-500">
            No payment sections available.
          </div>
        )}

        {sections.map((section, idx) => (
          <div key={idx} className="border-t">
            {/* Section Header */}
            <div
              className="px-4 py-2 font-semibold text-sm flex justify-between"
              style={{ backgroundColor: "#ecf3ff" }}
            >
              <span>
                ■ {(section.sectionName || "").toUpperCase()}
              </span>
              {section.sectionTotal !== null &&
                section.sectionTotal !== undefined && (
                  <span className="font-bold">
                    £{section.sectionTotal}
                  </span>
                )}
            </div>

            {/* Section Items */}
            <table className="w-full text-sm">
              <tbody>
                {Array.isArray(section.items) &&
                  section.items.map((item, i) => (
                    <tr
                      key={i}
                      className="border-b hover:bg-gray-50"
                    >
                      <td className="p-3">
                        {item.description || "-"}
                      </td>
                      <td className="p-3 text-right font-medium">
                        £{item.amount || "0"}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>

      {/* ================= PDF PREVIEW ================= */}
      {preview_url && (
        <div className="bg-white border rounded-lg shadow">
          <div className="bg-[#eef4ff] px-4 py-2 rounded-t-lg border-b">
            <h3 className="text-base font-semibold text-[#1d5aa9]">
              Document Preview
            </h3>
          </div>

          <iframe
          width="100%"
            height="600"
            src={preview_url}
            className="w-full h-[600px] border-none rounded-b-lg"
            title="Property Statement Preview"
          />
        </div>
      )}
    </div>
  );
}
